import { Inject, Injectable, Injector } from '@angular/core';

import { Ultraship_FlowService } from './Ultraship.flow.index';


import { $types } from './app.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Ultraship = this.injector.get(Ultraship_FlowService);
  }

    public Ultraship: Ultraship_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
